import React from 'react';
import RetroSquare from '../components/RetroSquare';

const LogoDemo = () => {
  return (
    <div className="max-w-lg mx-auto mt-8">
      <RetroSquare size={400} />
      <p className="text-center mt-8 text-lg font-['VT323'] text-black/60">
        Click the logo to randomize • Use button to save
      </p>
    </div>
  );
};

export default LogoDemo; 